<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户名称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">待确认</a-select-option>
                  <a-select-option :value="2">已驳回</a-select-option>
                  <a-select-option :value="3">已收款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="提现类型" prop="withdrawType">
                <a-select v-model="queryParam.withdrawType" placeholder="请选择提现类型" allow-clear>
                  <a-select-option :value="1">积分提现</a-select-option>
                  <a-select-option :value="2">现金提现</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="申请时间" prop="timeRange">
                <a-range-picker v-model="queryParam.timeRange" style="width: 100%" format="YYYY-MM-DD" />
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="手续费用" prop="procedureCharge">-->
<!--                  <a-input v-model="queryParam.procedureCharge" placeholder="请输入手续费用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="提现积分" prop="money">-->
<!--                  <a-input v-model="queryParam.money" placeholder="请输入提现积分" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="到账金额" prop="arrivalAmount">-->
<!--                  <a-input v-model="queryParam.arrivalAmount" placeholder="请输入到账金额" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="打款证明" prop="prove">-->
<!--                  <a-input v-model="queryParam.prove" placeholder="请输入打款证明" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="驳回原因" prop="reason">-->
<!--                  <a-input v-model="queryParam.reason" placeholder="请输入驳回原因" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- 统计信息 -->
<!--        <a-row :gutter="16" style="margin-bottom: 16px;">
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
              <a-statistic title="总提现积分" :value="statistics.totalMoney" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: white;">
              <a-statistic title="总手续费用" :value="statistics.totalFee" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: white;">
              <a-statistic title="总到账金额" :value="statistics.totalArrival" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); color: white;">
              <a-statistic title="审核中" :value="statistics.pendingCount" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); color: white;">
              <a-statistic title="已通过" :value="statistics.passedCount" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
          <a-col :span="4">
            <a-card :bordered="false" style="background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%); color: white;">
              <a-statistic title="已驳回" :value="statistics.rejectedCount" :value-style="{ color: '#fff', fontSize: '20px' }" />
            </a-card>
          </a-col>
        </a-row>-->

        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="avatar" slot-scope="text, record">
          <img v-viewer v-if="record.avatar" :src="processImageUrl(record.avatar)"
               style="width: 50px; height: 50px; border-radius: 50%;" />
        </span>

        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="text === 1" color="green">待确认</a-tag>
          <a-tag v-else-if="text === 2" color="red">已驳回</a-tag>
          <a-tag v-else-if="text === 3" color="red">已收款</a-tag>
        </span>

        <span slot="invoice" slot-scope="text, record">
          <span v-if="record.invoice" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 4px;">
            <img v-viewer v-for="(item, index) in record.invoice.split(',')" :key="index"
                 :src="processImageUrl(item)" style="width: 40px; height: 40px; border-radius: 4px; cursor: pointer;" />
          </span>
          <span v-else>-</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a v-if="record.status === 0" @click="handlePass(record)" v-hasPermi="['withdraw:apply:edit']" style="color: #52c41a;">
            <a-icon type="check" />通过
          </a>
          <a-divider type="vertical" v-if="record.status === 0" />
          <a v-if="record.status === 0" @click="handleReject(record)" v-hasPermi="['withdraw:apply:edit']" style="color: #ff4d4f;">
            <a-icon type="close" />驳回
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 驳回原因弹窗 -->
    <a-modal
      title="驳回原因"
      :visible="rejectVisible"
      :confirm-loading="rejectLoading"
      @ok="confirmReject"
      @cancel="rejectVisible = false"
    >
      <a-form-model :model="rejectForm" :rules="rejectRules" ref="rejectForm">
        <a-form-model-item label="驳回原因" prop="reason">
          <a-textarea
            v-model="rejectForm.reason"
            placeholder="请输入驳回原因"
            :rows="4"
            :maxlength="200"
            show-count
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageApply,listApply, delApply, checkApply } from '@/api/withdraw/apply'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'Apply',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        nickname:null,
        status: null,
        withdrawType: null,
        type: null,
        timeRange: null,
        startTime: null,
        endTime: null,
        procedureCharge: null,
        money: null,
        invoice: null,
        arrivalAmount: null,
        prove: null,
        reason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户名称',
          dataIndex: 'nickname',
          width: 180,
          align: 'center',
          customRender: (text, record) => {
            return (
              <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                <div style="display: flex; align-items: center;">
                  <img v-if={record.avatar} src={this.processImageUrl(record.avatar)} style="width: 32px; height: 32px; border-radius: 50%; margin-right: 8px;" />
                  <span>{text}</span>
                </div>
                <div style="font-size: 12px; color: #8c8c8c; margin-top: 4px;">{record.mobile}</div>
              </div>
            )
          }
        },
        {
          title: '提现方式',
          dataIndex: 'type',
          width: 90,
          align: 'center',
          customRender: (text) => {
            const typeMap = {
              1: '微信',
              2: '支付宝'
            }
            return typeMap[text] || '-'
          }
        },
        {
          title: '提现类型',
          dataIndex: 'withdrawType',
          width: 100,
          align: 'center',
          customRender: (text) => {
            const withdrawTypeMap = {
              1: { text: '积分提现', color: 'blue' },
              2: { text: '现金提现', color: 'purple' }
            }
            if (text === 1 || text === 2) {
              return <a-tag color={withdrawTypeMap[text].color}>{withdrawTypeMap[text].text}</a-tag>
            }
            return '-'
          }
        },
        {
          title: '发票凭证',
          dataIndex: 'invoice',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'invoice' },
        },
        {
          title: '提现积分',
          dataIndex: 'money',
          width: 100,
          align: 'center',
          customRender: (text) => {
            return text ? text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '驳回原因',
          dataIndex: 'reason',
          width: 150,
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        // {
        //   title: '到账金额',
        //   dataIndex: 'arrivalAmount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '打款证明',
        //   dataIndex: 'prove',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      // 统计数据
      statistics: {
        totalMoney: 0,
        totalFee: 0,
        totalArrival: 0,
        pendingCount: 0,
        passedCount: 0,
        rejectedCount: 0
      },
      // 驳回弹窗
      rejectVisible: false,
      rejectLoading: false,
      rejectForm: {
        id: null,
        reason: ''
      },
      rejectRules: {
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 查询提现申请列表 */
    getList () {
      this.loading = true
      // 处理时间范围
      const params = { ...this.queryParam }
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0].format('YYYY-MM-DD')
        params.endTime = params.timeRange[1].format('YYYY-MM-DD')
      }
      delete params.timeRange

      pageApply(params).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.calculateStatistics()
        this.loading = false
      })
    },
    /** 计算统计数据 */
    calculateStatistics () {
      const list = this.list || []
      this.statistics = {
        totalMoney: 0,
        totalFee: 0,
        totalArrival: 0,
        pendingCount: 0,
        passedCount: 0,
        rejectedCount: 0
      }

      list.forEach(item => {
        // 提现积分
        if (item.money) {
          this.statistics.totalMoney += parseFloat(item.money)
        }
        // 手续费用
        if (item.procedureCharge) {
          this.statistics.totalFee += parseFloat(item.procedureCharge)
        }
        // 到账金额
        if (item.arrivalAmount) {
          this.statistics.totalArrival += parseFloat(item.arrivalAmount)
        }
        // 状态统计
        if (item.status === 0) {
          this.statistics.pendingCount++
        } else if (item.status === 1) {
          this.statistics.passedCount++
        } else if (item.status === 2) {
          this.statistics.rejectedCount++
        }
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        nickname: undefined,
        status: undefined,
        withdrawType: undefined,
        type: undefined,
        timeRange: undefined,
        startTime: undefined,
        endTime: undefined,
        procedureCharge: undefined,
        money: undefined,
        invoice: undefined,
        arrivalAmount: undefined,
        prove: undefined,
        reason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 通过按钮操作 */
    handlePass (row) {
      this.$confirm({
        title: '确认通过?',
        content: '确认通过该提现申请吗？',
        onOk: () => {
          return checkApply({ id: row.id, status: 1 }).then(() => {
            this.getList()
            this.$message.success('审核通过成功', 3)
          })
        },
        onCancel () {}
      })
    },
    /** 驳回按钮操作 */
    handleReject (row) {
      this.rejectForm = {
        id: row.id,
        reason: ''
      }
      this.rejectVisible = true
      this.$nextTick(() => {
        this.$refs.rejectForm && this.$refs.rejectForm.clearValidate()
      })
    },
    /** 确认驳回 */
    confirmReject () {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          this.rejectLoading = true
          checkApply({ id: this.rejectForm.id, status: 2, reason: this.rejectForm.reason }).then(() => {
            this.rejectVisible = false
            this.getList()
            this.$message.success('驳回成功', 3)
          }).finally(() => {
            this.rejectLoading = false
          })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delApply(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('withdraw/apply/export', {
            ...that.queryParam
          }, `提现申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
